
import { Nullable } from '@/shared/types/app.types'

export interface LocalTopographicSubsetLaboratoryModalComboElement {
    id: number
    text: string
}

export interface LocalTopographicSubsetLaboratoryModalState {
    id: Nullable<number>
    active: boolean
    topographicCodeId: Nullable<number>
    topographicCodeSelected: Nullable<LocalTopographicSubsetLaboratoryModalComboElement>
}
export const initialLocalTopographicSubsetLaboratoryModalState =
    (): LocalTopographicSubsetLaboratoryModalState => ({
        id: null,
        active: false,
        topographicCodeId: null,
        topographicCodeSelected: null
    })
